module.exports = __webpack_public_path__ + "img/9.6.1.81f6c925.svg";